// extracted by mini-css-extract-plugin
export default {"container":"AgreePersonalInfo_container__HrJan","contentsContainer":"AgreePersonalInfo_contentsContainer__0-96q"};